// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"07d6e8a5","239":"d7ee0375","455":"5768431c"}[chunkId] + ".chunk.js";
};